import { useParams } from 'react-router-dom';
import { SITE_ID_PARAM_NAME } from 'src/core/config/navigationRoutes';

export function useURLSiteParam(): string
{
    const params = useParams();
    const siteId = params[ SITE_ID_PARAM_NAME ];
    return siteId ?? '';
}